import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50c07b7a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=50c07b7a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mer_supplier_admin_pSW1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c07b7a')) {
      api.createRecord('50c07b7a', component.options)
    } else {
      api.reload('50c07b7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50c07b7a", function () {
      api.rerender('50c07b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThemePicker/index.vue"
export default component.exports